<template>
      <v-container>
        <h2>
          Cities
        </h2>
        <Cities/>
      </v-container>
</template>

<script>
import Cities from "../components/cities.vue";

export default {
  name: 'cities_crud_table',
  props: ["text"],
  components: { Cities }
}
</script>
